export default function AdminStat({ label, value, note, icon }: { label: string; value: string; note?: string; icon: string }) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center justify-between">
        <p className="font-label uppercase tracking-widest text-[11px] text-foreground-500">{label}</p>
        <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-lg"><i className={icon}></i></span>
      </div>
      <p className="mt-3 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950 leading-none">{value}</p>
      {note && <p className="mt-2 text-xs text-foreground-500">{note}</p>}
    </div>
  );
}